'use client';

import { useStorePageConfig } from '@/app/(football)/[team]/store/_context/context';

export default function TitleSection() {
  const { titleSection } = useStorePageConfig();

  return (
    <section className="flex w-full flex-col items-center gap-2">
      <h1 className="w-full text-center text-2xl leading-[34px] font-extrabold text-store-list-title-text">
        {titleSection.title}
      </h1>
      <div className="flex w-full flex-col items-center gap-0.5">
        <p className="w-full text-center text-sm leading-[18px] font-medium text-store-list-highlight-text">
          {titleSection.highlight}
        </p>
        <p className="w-full text-center text-sm leading-[18px] font-medium text-store-list-description-text">
          {titleSection.description}
        </p>
      </div>
    </section>
  );
}
